<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-view">
    <!-- <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert> -->
    <div class="demo-alignment">

			<div class="fill-row-loading">
				<div
					:class="{'activeLoading':activeLoading}"
					@click="openLoading(type)"
					v-for="type in types"
					:key="type"
					:id="[`loading-${type}`]"
					class="vs-con-loading__container loading-example">
				</div>
			</div>
     
		</div>
    <div id="user-data" >

      <vx-card  class="mb-base">
        <!-- Avatar -->
        <div class="vx-row">
           <!-- Avatar Col -->
          <!-- <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <img v-if="user.image" :src="user.image" class="rounded w-full" />
             <i v-else class="fad fa-user-circle fa-5x ml-5 text-primary"></i>
            </div>
          </div> -->
          <div class="vx-col">
        <div class="flex items-start flex-col sm:flex-row">
          <img v-if="user.image" class="mr-8 rounded h-24 w-24" :src="user.image" size="80px"  />
          <i v-else class="fad fa-user-circle fa-5x ml-5 text-primary"></i>
          <!-- <vs-avatar :src="employee.user.image" size="80px" class="mr-4" /> -->
         
          <div v-if="id==$route.params.userId">
            <p class="text-lg font-medium mb-2 mt-4 sm:mt-0"></p>
            <input type="file" class="hidden" ref="update_avatar_input" name="imagem"   accept="image/*">

            <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
            <vs-button class="mr-4 ml-2 mb-4" size="small" @click="$refs.update_avatar_input.click()">Carregar foto</vs-button>
            <!-- <vs-button type="border" class="mr-4" @click="$refs.update_avatar_input.click()">Change Avatar</vs-button> -->

            <vs-button v-if="imagem!==''" type="border" color="primary" @click="saveProfilePicture">
              
              <i class="fas fa-sync fa-2x"></i>
            
              
              </vs-button>
            <p v-if="process==false" class="text-sm mt-2 ml-2">Formatos suportados <br> JPG, JPEG or PNG.</p>
           <p v-if="process==true"> <vs-progress indeterminate color="primary"></vs-progress></p>
          </div>
        </div>
      </div>

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Nome</td>
                <td>{{ user.name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Apelido</td>
                  <td>{{ user.surname }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Email</td>
                 <td>{{ user.email }}</td>
              </tr>
            </table>
          </div>
          
           <div v-if="roleAdministrador" class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Estado</td>
                <td>

                  <!-- <vs-button @click="ActivarDesactivar">okok</vs-button> -->
                     <vs-switch color="success" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" @click="ActivarDesactivar" v-model="user.status">
        <span slot="on">Activo</span>
        <span slot="off">Inactivo</span>
      </vs-switch>
                </td>
              </tr>
            <tr>
              <td class="font-semibold">Senha</td>
                <td>
                  
                  <vs-button size="small" color="warning" @click="popupSenha=true">
                    Alterar Senha
                  </vs-button>
                </td>
              </tr>
             
            </table>
          </div>
         

        </div>

      </vx-card>

     
    <vs-popup class="holamundo" title="Alterar Senha" :active.sync="popupSenha">
 

              
      <label class="mt-8" for="">Nova Senha</label>
      <vs-input  class="w-full mt-2 mb-5"   v-model="password" />
      
      
      
  
<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2"  @click="updatePassword">Alterar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </vs-popup>
      <!-- Permissions -->
      <vx-card>
          <vs-tabs>
    <vs-tab label="Permissões" icon-pack="feather" icon="icon-lock">
    
            <vs-divider />
        <div class="block overflow-x-auto">
          <table class="w-full permissions-table">
            <tr>
              <!--
                You can also use `Object.keys(Object.values(data_local.permissions)[0])` this logic if you consider,
                our data structure. You just have to loop over above variable to get table headers.
                Below we made it simple. So, everyone can understand.
               -->
              <th class="font-semibold text-base text-left px-3 py-2" v-for="heading in ['Módulo', 'Leitura', 'Escrita', 'Actualizar', 'Eliminar', 'Aprovação']" :key="heading">{{ heading }}</th>
            </tr>

          
 <tr >
   
              <td class="px-3 py-2">Funcionarios</td>
              <td class="px-3 py-2">
                <!-- <vs-checkbox vs-value="list Employee" v-model="permission_name" class="pointer-events" /> -->
               <vs-checkbox :disabled="!roleAdministrador" vs-value="list Employee" v-model="canListEmpPro" class="pointer-events" />
              </td>
              <td class="px-3 py-2">
                 <vs-checkbox :disabled="!roleAdministrador" vs-value="create Employee" v-model="canAddEmpPro" class="pointer-events" />
              </td>
               <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="update Employee" v-model="canUpdateEmpPro" class="pointer-events" />
              </td>
               <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="delete Employee" v-model="canDeleteEmpPro" class="pointer-events" />
              </td>
              <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="approve Employee" v-model="canApproveEmpPro" class="pointer-events" />
              </td>
            </tr>


             <tr >
              <td class="px-3 py-2">Assiduidade</td>
              <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="list Attendance" v-model="canListAttendancePro" class="pointer-events" />
              </td>
              <td class="px-3 py-2">
                 <vs-checkbox :disabled="!roleAdministrador" vs-value="create Attendance" v-model="canAddAttendancePro" class="pointer-events" />
              </td>
               <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="update Attendance" v-model="canUpdateAttendancePro" class="pointer-events" />
              </td>
               <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="delete Attendance" v-model="canDeleteAttendancePro" class="pointer-events" />
              </td>
              <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="approve Attendance" v-model="canApproveAttendancePro" class="pointer-events" />
              </td>
            </tr>

            <!-- <tr >
              <td class="px-3 py-2">Licenças</td>
              <td class="px-3 py-2">
                <vs-checkbox vs-value="list Employee" v-model="ok" class="pointer-events" />
              </td>
              <td class="px-3 py-2">
                 <vs-checkbox vs-value="create Employee" v-model="ok" class="pointer-events" />
              </td>
               <td class="px-3 py-2">
                <vs-checkbox vs-value="update Employee" v-model="ok" class="pointer-events" />
              </td>
               <td class="px-3 py-2">
                <vs-checkbox vs-value="delete Employee" v-model="ok" class="pointer-events" />
              </td>
              <td class="px-3 py-2">
                <vs-checkbox vs-value="approve Employee" v-model="ok" class="pointer-events" />
              </td>
            </tr> -->
            

              <tr >
              <td class="px-3 py-2">Folha de salario</td>
              <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="list Payroll" v-model="canListPayrollPro" class="pointer-events" />
              </td>
              <td class="px-3 py-2">
                 <vs-checkbox :disabled="!roleAdministrador" vs-value="create Payroll" v-model="canAddPayrollPro" class="pointer-events" />
              </td>
               <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="update Payroll" v-model="canUpdatePayrollPro" class="pointer-events" />
              </td>
               <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="delete Payroll" v-model="canDeletePayrollPro" class="pointer-events" />
              </td>
              <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="approve Payroll" v-model="canApprovePayrollPro" class="pointer-events" />
              </td>
            </tr>
            
            
            <tr >
              <td class="px-3 py-2">Gestão de férias</td>
              <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="list Vacation" v-model="canListVacationPro" class="pointer-events" />
              </td>
              <td class="px-3 py-2">
                 <vs-checkbox :disabled="!roleAdministrador" vs-value="create Vacation" v-model="canAddVacationPro" class="pointer-events" />
              </td>
               <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="update Vacation" v-model="canUpdateVacationPro" class="pointer-events" />
              </td>
               <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="delete Vacation" v-model="canDeleteVacationPro" class="pointer-events" />
              </td>
              <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="approve Vacation" v-model="canApproveVacationPro" class="pointer-events" />
              </td>
            </tr>
            
            <tr >
              <td class="px-3 py-2">Gestão de turnos</td>
              <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="list Shift" v-model="canListShiftPro" class="pointer-events" />
              </td>
              <td class="px-3 py-2">
                 <vs-checkbox :disabled="!roleAdministrador" vs-value="create Shift" v-model="canAddShiftPro" class="pointer-events" />
              </td>
               <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="update Shift" v-model="canUpdateShiftPro" class="pointer-events" />
              </td>
               <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="delete Shift" v-model="canDeleteShiftPro" class="pointer-events" />
              </td>
              <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="approve Shift" v-model="canApproveShiftPro" class="pointer-events" />
              </td>
            </tr>

            
            <tr >
              <td class="px-3 py-2">Gestão de horas extras</td>
              <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="list Extra_Hour" v-model="canListExtra_HourPro" class="pointer-events" />
              </td>
              <td class="px-3 py-2">
                 <vs-checkbox :disabled="!roleAdministrador" vs-value="create Extra_Hour" v-model="canAddExtra_HourPro" class="pointer-events" />
              </td>
               <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="update Extra_Hour" v-model="canUpdateExtra_HourPro" class="pointer-events" />
              </td>
               <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="delete Extra_Hour" v-model="canDeleteExtra_HourPro" class="pointer-events" />
              </td>
              <td class="px-3 py-2">
                <vs-checkbox :disabled="!roleAdministrador" vs-value="approve Extra_Hour" v-model="canApproveExtra_HourPro" class="pointer-events" />
              </td>
            </tr>
          </table>
        </div>
        <div class="vx-row">
      <div v-if="roleAdministrador" class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto  mt-2" type="border" color="warning" @click="RemoverPermissao">Remover</vs-button>
          <vs-button class="ml-4 mt-2" @click="saveData" >Adicionar</vs-button>
        </div>
      </div>
    </div>
    </vs-tab>

    <vs-tab label="Funções" icon-pack="feather" icon="icon-box">
 <vs-divider />


         <div class="vx-row mt-5">
    <div class="vx-col sm:w-1/2 w-full mb-2">
      <vs-checkbox :disabled="!roleAdministrador" vs-value="admin" v-model="roleAdminPro"><strong> Administrador </strong></vs-checkbox>
    
    </div>
    <div class="vx-col sm:w-1/2 w-full mb-2">
      <vs-checkbox :disabled="!roleAdministrador" vs-value="Funcionario" v-model="roleFuncionarioPro">Funcionário</vs-checkbox>
    </div>
  </div>
  <div class="vx-row">
   
    <div class="vx-col sm:w-1/2 w-full mb-2">
      <vs-checkbox :disabled="!roleAdministrador" vs-value="Gestor de Funcionario" v-model="roleGestorFuncionarioPro">Gestor de Funcionário</vs-checkbox>
    </div>
    
    <div class="vx-col sm:w-1/2 w-full mb-2">
     <vs-checkbox :disabled="!roleAdministrador" vs-value="Gestor de Assiduidade" v-model="roleAssiduidadePro">Gestor de Assiduidade</vs-checkbox>
    </div>
  </div>
  <div class="vx-row">
    <div class="vx-col sm:w-1/2 w-full mb-2">
     <vs-checkbox :disabled="!roleAdministrador" vs-value="Gestor de Ferias" v-model="roleFeriasPro">Gestor de férias</vs-checkbox>
    </div>
    <div class="vx-col sm:w-1/2 w-full mb-2">
    <vs-checkbox :disabled="!roleAdministrador" vs-value="Gestor de Remunerações" v-model="roleRemuneracoesPro">Gestor de Remunerações</vs-checkbox>
    </div>
  </div>
  <div class="vx-row">
    <div class="vx-col sm:w-1/2 w-full mb-2">
     <vs-checkbox :disabled="!roleAdministrador" vs-value="Gestor de Utilizadores" v-model="roleUtilizadoresPro">Gestor de Utilizadores</vs-checkbox>
    </div>
    <div class="vx-col sm:w-1/2 w-full mb-2">
     <vs-checkbox :disabled="!roleAdministrador" vs-value="Gestor de Horas" v-model="roleHorasPro">Gestor de Horas extras</vs-checkbox>
    </div>
  </div>
  <div class="vx-row">
   
    <div class="vx-col sm:w-1/2 w-full mb-2">
     <vs-checkbox :disabled="!roleAdministrador" vs-value="Gestor de Turnos" v-model="roleTurnosPro">Gestor de turnos</vs-checkbox>
   
    </div>
    <div class="vx-col sm:w-1/2 w-full mb-2">
     <vs-checkbox :disabled="!roleAdministrador" vs-value="Gestor de Recrutamento" v-model="roleRecrutamento">Recrutamento</vs-checkbox>
    </div>

  </div>
  
  <div v-if="roleAdministrador" class="vx-row">
    <div class="vx-col w-full">
      <vs-button  class="mr-3 mb-2" @click="saveRoles">Salvar</vs-button>
      <vs-button  color="warning" type="border" class="mb-2" @click="RemoverRole" >Remover</vs-button>
    </div>
  </div>
    </vs-tab>
  
  </vs-tabs>

       

      </vx-card>
       
    </div>
  </div>
</template>

<script>
import http from '../../../../http-common';
import vSelect from 'vue-select'
import { PermissionsMixin } from "../../../mixins/permissions";

export default {
  mixins:[PermissionsMixin],
    components: {
    vSelect
  },
  data() {
    return {
     user:[],
     selectedUser:"",
     permission_name:[],
     role_name:[],
     err:"",
     switch5:"",
       canListEmpPro: false,
     canAddEmpPro: false,
     canUpdateEmpPro: false,
     canDeleteEmpPro: false,
     canApproveEmpPro:false,

       canListAttendancePro: false,
     canAddAttendancePro: false,
     canUpdateAttendancePro: false,
     canDeleteAttendancePro: false,
     canApproveAttendancePro:false,

     canListPayrollPro: false,
     canAddPayrollPro: false,
     canUpdatePayrollPro: false,
     canDeletePayrollPro: false,
     canApprovePayrollPro:false,

     canLisVacationPro: false,
     canAddVacationPro: false,
     canUpdateVacationPro: false,
     canDeleteVacationPro: false,
     canApproveVacationPro:false,

     canListShiftPro: false,
     canAddShiftPro: false,
     canUpdateShiftPro: false,
     canDeleteShiftPro: false,
     canApproveShiftPro:false,

     canListExtra_HourPro:false,
     canAddExtra_HourPro:false,
     canUpdateExtra_HourPro:false,
     canDeleteExtra_HourPro:false,
     canApproveExtra_HourPro:false,


////////////////////////ROLES///////////////////
roleAdminPro:false,
roleFuncionarioPro:false,
roleGestorFuncionarioPro:false,
roleAssiduidadePro:false,
roleLicencasPro:false,
roleRemuneracoesPro:false,
roleUtilizadoresPro:false,
roleHorasPro:false,
roleTurnosPro:false,
roleFeriasPro:false,

roleRecrutamento:false,

     
popupSenha:false,
     imagem:"",
     process:"",
     password:"",
    }
  },

    mounted() {
    this.verifyRoles();
    this.initialize();
    
  },

  methods: {
    initialize(){
      this.getUser();
      this.getCurrentUser();
    },



      getCurrentUser(){
      let authUser = localStorage.getItem('user');
      var authUserObject = JSON.parse(authUser);
       this.id = authUserObject.id;
    },
    getUser() {
       this.$vs.loading()
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
        params:{
          type:1
        }
      };
      
      http
        .get(`/users/users/${this.$route.params.userId}`, config)
        .then((result) => {
          this.user = result.data.User;
          this.$vs.loading.close();
// alert("2")
        })
        .catch((error) => {
          error;
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
         
        });
    },

    

    clean(){
      this.permission_name=[]
    },

    async updatePassword() {
  
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      const data = {
          password:this.password

          
      };

      this.$validator.validateAll();
      await http
        .patch(`/users/passwords_update/${this.$route.params.userId}`, data, config)
        .then((success) => {
          success;
        this.popupSenha=false,
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Senha alterada com sucesso",
            color: "success",
            position: "top-right",
          })
        })
       .catch((error) => {
          error;
          if(error.response.status==422 ){
          this.err= error.response.data
          this.$vs.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          }else{
          this.$vs.notify({
            title: "Erro",
            text: "Aconteceu algum erro",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          }
          
        });
    },

 async ActivarDesactivar() {
        this.$vs.loading()
     
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

       
      

      this.$validator.validateAll();
      await http
        .patch(`/users/disable/${this.$route.params.userId}`,{}, config)
        .then((success) => {
          success;
          this.$vs.loading.close();
        this.popupSenha=false,
          
          this.$vs.notify({
            title: "Sucesso",
            text: "Estado alterado com sucesso",
            color: "success",
            position: "top-right",
          })
        })
       .catch((error) => {
          error;
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
          if(error.response.status==422 ){
          this.err= error.response.data
          console.log(this.err)
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          }else{
          this.$vs.notify({
            title: "Erro",
            text: "Aconteceu algum erro",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          }
          
        });
    },

   
    RemoverPermissao() {
      //////////////////////////permissoes de funcionario//////////////////
       if(this.canListEmpPro !=true){
this.permission_name.push("list Employee");
        }

         if(this.canAddEmpPro !=true){
this.permission_name.push("create Employee");
        }
           if(this.canUpdateEmpPro !=true){
this.permission_name.push("update Employee");
        }

           if(this.canDeleteEmpPro !=true){
this.permission_name.push("delete Employee");
        }
      
        if(this.canApproveEmpPro !=true){
this.permission_name.push("approve Employee");
        }
          //////////////////////////permissoes de EFECTIVIDADE//////////////////
       if(this.canListAttendancePro !=true){
this.permission_name.push("list Attendance");
        }

         if(this.canAddAttendancePro !=true){
this.permission_name.push("create Attendance");
        }
           if(this.canUpdateAttendancePro !=true){
this.permission_name.push("update Attendance");
        }

           if(this.canDeleteAttendancePro !=true){
this.permission_name.push("delete Attendance");
        }
      
        if(this.canApproveAttendancePro !=true){
this.permission_name.push("approve Attendance");
        }
                //////////////////////////permissoes de FOLHA//////////////////
       if(this.canListPayrollPro !=true){
this.permission_name.push("list Payroll");
        }

         if(this.canAddPayrollPro !=true){
this.permission_name.push("create Payroll");
        }
           if(this.canUpdatePayrollPro !=true){
this.permission_name.push("update Payroll");
        }

           if(this.canDeletePayrollPro !=true){
this.permission_name.push("delete Payroll");
        }
      
        if(this.canApprovePayrollPro !=true){
this.permission_name.push("approve Payroll");
        }

               //////////////////////////permissoes de FERIAS//////////////////
               if(this.canListVacationPro !=true){
this.permission_name.push("list Vacation");
        }

         if(this.canAddVacationPro !=true){
this.permission_name.push("create Vacation");
        }
           if(this.canUpdateVacationPro !=true){
this.permission_name.push("update Vacation");
        }

           if(this.canDeleteVacationPro !=true){
this.permission_name.push("delete Vacation");
        }
      
        if(this.canApproveVacationPro !=true){
this.permission_name.push("approve Vacation");
        }

                       //////////////////////////permissoes de TURNOS//////////////////
                       if(this.canListShiftPro !=true){
this.permission_name.push("list Shift");
        }

         if(this.canAddShiftPro !=true){
this.permission_name.push("create Shift");
        }
           if(this.canUpdateShiftPro !=true){
this.permission_name.push("update Shift");
        }

           if(this.canDeleteShiftPro !=true){
this.permission_name.push("delete Shift");
        }
      
        if(this.canApproveShiftPro !=true){
this.permission_name.push("approve Shift");
        }


                       //////////////////////////permissoes de HORAS EXTRAS//////////////////
                       if(this.canListExtra_HourPro !=true){
this.permission_name.push("list Extra_Hour");
        }

         if(this.canAddExtra_HourPro !=true){
this.permission_name.push("create Extra_Hour");
        }
           if(this.canUpdateExtra_HourPro !=true){
this.permission_name.push("update Extra_Hour");
        }

           if(this.canDeleteExtra_HourPro !=true){
this.permission_name.push("delete Extra_Hour");
        }
      
        if(this.canApproveExtra_HourPro !=true){
this.permission_name.push("approve Extra_Hour");
        }
        this.permission_name = this.permission_name.filter(element => element !== true && element !== false);
      this.$vs.loading()
     
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      const data = {
        permission_name:this.permission_name,

      };
      this.$validator.validateAll();
    http
        .post(`/permissions/remove_permissions/${this.$route.params.userId}`, data, config)
        .then((success) => {
          success;
          this.clean()
          
          this.$validator.reset();
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Permissões Removidas com sucesso!",
            color: "success",
            position: "top-right",
          });
          location.reload()
        })
        .catch((error) => {
          error;
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
          if(error.response.status==422 ){
          this.err= error.response.data
          this.$vs.notify({
            title: "Sucesso",
            text: this.err,
            color: "danger",
            position: "top-right",
          })
          }else if(error.response.status==200 ){ 
             this.err= error.response.data
          console.log(this.err)
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          } else{
this.$vs.loading.close();
          
          this.$vs.notify({
            title: "Erro",
            text: "falha ao salvar Utilizador ",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
          }
          
        });
    
       
    },

teste(){
  if(this.roleAdmin ==true){
this.role_name.push("admin");
        }
},

    RemoverRole() {
      //////////////////////////Role//////////////////
       if(this.roleAdminPro !=true){
this.role_name.push("admin");
        }

        if(this.roleFuncionarioPro !=true){
this.role_name.push("Funcionario");
        }
        if(this.roleGestorFuncionarioPro !=true){
this.role_name.push("Gestor de Funcionario");
        }

        if(this.roleAssiduidadePro !=true){
this.role_name.push("Gestor de Assiduidade");
        }
        if(this.roleLicencasPro !=true){
this.role_name.push("Gestor de Licenças");
        }
        if(this.roleUtilizadoresPro !=true){
this.role_name.push("Gestor de Utilizadores");
        }
        if(this.roleRemuneracoesPro !=true){
this.role_name.push("Gestor de Remunerações");
        }

        if(this.roleHorasPro !=true){
this.role_name.push("Gestor de Horas");
        }

        if(this.roleTurnosPro !=true){
this.role_name.push("Gestor de Turnos");
        }

        if(this.roleFeriasPro !=true){
this.role_name.push("Gestor de Ferias");
        }
        this.role_name = this.role_name.filter(element => element !== true && element !== false);
      this.$vs.loading()
     
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      const data = {
        role_name:this.role_name,

      };
      this.$validator.validateAll();
    http
        .post(`/permissions/remove_roles/${this.$route.params.userId}`, data, config)
        .then((success) => {
          success;
          this.clean()
          
          this.$validator.reset();
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Funcões Removidas com sucesso!",
            color: "success",
            position: "top-right",
          });
          // location.reload()
        })
        .catch((error) => {
          error;
          this.$vs.loading.close();
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
          if(error.response.status==422 ){
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: this.err,
            color: "danger",
            position: "top-right",
          })
          }else if(error.response.status==200 ){ 
             this.err= error.response.data
             this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          } else{
this.$vs.loading.close();
          
          this.$vs.notify({
            title: "Erro",
            text: "falha ao salvar Utilizador ",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
          }
          
        });
    
       
    },
      saveData() {
      

      /////////////////////////////////////////// Permissoes de funcionarios //////////////////////////
        if(this.canListEmpPro !=true){
this.permission_name.push(this.canListEmpPro);
        }

         if(this.canAddEmpPro !=true){
this.permission_name.push(this.canAddEmpPro);
        }
           if(this.canUpdateEmpPro !=true){
this.permission_name.push(this.canUpdateEmpPro);
        }

           if(this.canDeleteEmpPro !=true){
this.permission_name.push(this.canDeleteEmpPro);
        }
      
        if(this.canApproveEmpPro !=true){
this.permission_name.push(this.canApproveEmpPro);
        }

        //////////////////////////////////////////////////////Permissoes de EFECTIVIDADE///////////////////
     if(this.canListAttendancePro !=true){
this.permission_name.push(this.canListAttendancePro);
        }

         if(this.canAddAttendancePro !=true){
this.permission_name.push(this.canAddAttendancePro);
        }
           if(this.canUpdateAttendancePro !=true){
this.permission_name.push(this.canUpdateAttendancePro);
        }

           if(this.canDeleteAttendancePro !=true){
this.permission_name.push(this.canDeleteAttendancePro);
        }
      
        if(this.canApproveAttendancePro !=true){
this.permission_name.push(this.canApproveAttendancePro);
        }

               //////////////////////////////////////////////////////Permissoes de folha///////////////////
     if(this.canListPayrollPro !=true){
this.permission_name.push(this.canListPayrollPro);
        }

         if(this.canAddPayrollPro !=true){
this.permission_name.push(this.canAddPayrollPro);
        }
           if(this.canUpdatePayrollPro !=true){
this.permission_name.push(this.canUpdatePayrollPro);
        }

           if(this.canDeletePayrollPro !=true){
this.permission_name.push(this.canDeletePayrollPro);
        }
      
        if(this.canApprovePayrollPro !=true){
this.permission_name.push(this.canApprovePayrollPro);
        }

                  //////////////////////////////////////////////////////Permissoes de ferias///////////////////
     if(this.canListVacationPro !=true){
this.permission_name.push(this.canListVacationPro);
        }

         if(this.canAddVacationPro !=true){
this.permission_name.push(this.canAddVacationPro);
        }
           if(this.canUpdateVacationPro !=true){
this.permission_name.push(this.canUpdateVacationPro);
        }

           if(this.canDeleteVacationPro !=true){
this.permission_name.push(this.canDeleteVacationPro);
        }
      
        if(this.canApproveVacationPro !=true){
this.permission_name.push(this.canApproveVacationPro);
        }

                        //////////////////////////////////////////////////////Permissoes de turnos///////////////////
     if(this.canListShiftPro !=true){
this.permission_name.push(this.canListShiftPro);
        }

         if(this.canAddShiftPro !=true){
this.permission_name.push(this.canAddShiftPro);
        }
           if(this.canUpdateShiftPro !=true){
this.permission_name.push(this.canUpdateShiftPro);
        }

           if(this.canDeleteShiftPro !=true){
this.permission_name.push(this.canDeleteShiftPro);
        }
      
        if(this.canApproveShiftPro !=true){
this.permission_name.push(this.canApproveShiftPro);
        }


                                //////////////////////////////////////////////////////Permissoes de HORAS EXTRAS///////////////////
     if(this.canListExtra_HourPro !=true){
this.permission_name.push(this.canListExtra_HourPro);
        }

         if(this.canAddExtra_HourPro !=true){
this.permission_name.push(this.canAddExtra_HourPro);
        }
           if(this.canUpdateExtra_HourPro !=true){
this.permission_name.push(this.canUpdateExtra_HourPro);
        }

           if(this.canDeleteExtra_HourPro !=true){
this.permission_name.push(this.canDeleteExtra_HourPro);
        }
      
        if(this.canApproveExtra_HourPro !=true){
this.permission_name.push(this.canApproveExtra_HourPro);
        }
        this.permission_name = this.permission_name.filter(element => element !== true && element !== false);
      this.$vs.loading()
     
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      const data = {
        permission_name:this.permission_name,

      };
      this.$validator.validateAll();
    http
        .post(`/permissions/grant_permissions/${this.$route.params.userId}`, data, config)
        .then((success) => {
          success;
          this.clean()
        
          this.$validator.reset();
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Permissões atribuidas com sucesso",
            color: "success",
            position: "top-right",
          });
          // location.reload()
        })
        .catch((error) => {
          error;
          this.$vs.loading.close();
          if(error.response.status==422 ){
          this.err= error.response.data
          this.$vs.notify({
            title: "Sucesso",
            text: this.err,
            color: "danger",
            position: "top-right",
          })
          }else if(error.response.status==200 ){ 
             this.err= error.response.data
             this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          } else{
this.$vs.loading.close();
          
          this.$vs.notify({
            title: "Erro",
            text: "falha ao salvar Utilizador ",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
          }
          
        });
    
       
    },

      saveRoles() {

      /////////////////////////////////////////// Permissoes de funcionarios //////////////////////////
     
     this.role_name=[]
      if(this.roleAdmin !=true ){
this.role_name.push(this.roleAdminPro);
        }
 if(this.roleFuncionario !=true){
this.role_name.push(this.roleFuncionarioPro);
        }
     if(this.roleGestorFuncionario !=true){
this.role_name.push(this.roleGestorFuncionarioPro);
        }

  if(this.roleAssiduidade !=true){
this.role_name.push(this.roleAssiduidadePro);
        }
         if(this.roleRemuneracoes !=true){
this.role_name.push(this.roleRemuneracoesPro);
        }
           if(this.roleUtilizadores !=true){
this.role_name.push(this.roleUtilizadoresPro);
        }

        if(this.roleHorasPro !=true){
this.role_name.push(this.roleHorasPro);
        }

        if(this.roleTurnosPro !=true){
this.role_name.push(this.roleTurnosPro);
        }

        if(this.roleFeriasPro !=true){
this.role_name.push(this.roleFeriasPro);
        }
        if(this.roleRecrutamento !=true){
this.role_name.push(this.roleRecrutamento);
        }

        
        this.role_name = this.role_name.filter(element => element !== true && element !== false);
      this.$vs.loading()
     
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      const data = {
        role_name:this.role_name,

      };
      this.$validator.validateAll();
    http
        .post(`/permissions/grant_roles/${this.$route.params.userId}`, data, config)
        .then((success) => {
          success;
          // location.reload()
          this.clean()
          this.$validator.reset();
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Gravado com sucesso",
            color: "success",
            position: "top-right",
          });
        })
        .catch((error) => {
          error;
          this.$vs.loading.close();
          if(error.response.status==422 ){
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: this.err,
            color: "danger",
            position: "top-right",
          })
          }else if(error.response.status==200 ){ 
             this.err= error.response.data
             this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          } else{
this.$vs.loading.close();
          
          this.$vs.notify({
            title: "Erro",
            text: "falha ao salvar Utilizador ",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
          }
          
        });
    
       
    },
            verifyPermission(){
      this.canListEmpPro=this.canAddEmpPro=this.canUpdateEmpPro=this.canDeleteEmpPro=this.canApproveEmpPro= this.canListAttendancePro=this.canAddAttendancePro=this.canUpdateAttendancePro=this.canDeleteAttendancePro=this.canApproveAttendancePro=this.canListPayrollPro=this.canAddPayrollPro=this.canUpdatePayrollPro=this.canDeletePayrollPro=this.canApprovePayrollPro=false;//aumente a lista de variaveis aqui

      this.canLisVacationPro= false,
      this.canAddVacationPro= false,
      this.canUpdateVacationPro= false,
      this.canDeleteVacationPro= false,
      this.canApproveVacationPro=false,

      this.canListShiftPro= false,
      this.canAddShiftPro= false,
      this.canUpdateShiftPro= false,
      this.canDeleteShiftPro= false,
      this.canApproveShiftPro=false,

      this.canListExtra_HourPro=false,
      this.canAddExtra_HourPro=false,
      this.canUpdateExtra_HourPro=false,
      this.canDeleteExtra_HourPro=false,
      this.canApproveExtra_HourPro=false;

       for(let permission in this.user.permission){
        ///////////////FUNCIONARIO
          if(this.user.permission[permission].name == "list Employee"){
            this.canListEmpPro = true;
          }
           if(this.user.permission[permission].name == "create Employee"){
            this.canAddEmpPro = true;
          }
          if(this.user.permission[permission].name == "update Employee"){
            this.canUpdateEmpPro = true;
          }
           if(this.user.permission[permission].name == "delete Employee"){
            this.canDeleteEmpPro = true;
          }
           if(this.user.permission[permission].name == "approve Employee"){
            this.canApproveEmpPro = true;
          }

          /////////////////////////EFECTIVIDADE
           if(this.user.permission[permission].name == "list Attendance"){
            this.canListAttendancePro = true;
          }
           if(this.user.permission[permission].name == "create Attendance"){
            this.canAddAttendancePro = true;
          }
          if(this.user.permission[permission].name == "update Attendance"){
            this.canUpdateAttendancePro = true;
          }
           if(this.user.permission[permission].name == "delete Attendance"){
            this.canDeleteAttendancePro = true;
          }
           if(this.user.permission[permission].name == "approve Attendance"){
            this.canApproveAttendancePro = true;
          }

            /////////////////////////PROCESSAR SALARIO
           if(this.user.permission[permission].name == "list Payroll"){
            this.canListPayrollPro = true;
          }
           if(this.user.permission[permission].name == "create Payroll"){
            this.canAddPayrollPro = true;
          }
          if(this.user.permission[permission].name == "update Payroll"){
            this.canUpdatePayrollPro = true;
          }
           if(this.user.permission[permission].name == "delete Payroll"){
            this.canDeletePayrollPro = true;
          }
           if(this.user.permission[permission].name == "approve Payroll"){
            this.canApprovePayrollPro = true;
          }
   /////////////////////////PROCESSAR turnos
   if(this.user.permission[permission].name == "list Shift"){
            this.canListShiftPro = true;
          }
           if(this.user.permission[permission].name == "create Shift"){
            this.canAddShiftPro = true;
          }
          if(this.user.permission[permission].name == "update Shift"){
            this.canUpdateShiftPro = true;
          }
           if(this.user.permission[permission].name == "delete Shift"){
            this.canDeleteShiftPro = true;
          }
           if(this.user.permission[permission].name == "approve Shift"){
            this.canApproveShiftPro = true;
          }
          
             /////////////////////////PROCESSAR ferias
   if(this.user.permission[permission].name == "list Vacation"){
            this.canListVacationPro = true;
          }
           if(this.user.permission[permission].name == "create Vacation"){
            this.canAddVacationPro = true;
          }
          if(this.user.permission[permission].name == "update Vacation"){
            this.canUpdateVacationPro = true;
          }
           if(this.user.permission[permission].name == "delete Vacation"){
            this.canDeleteVacationPro = true;
          }
           if(this.user.permission[permission].name == "approve Vacation"){
            this.canApproveVacationPro = true;
          }

                    /////////////////////////PROCESSAR ferias
   if(this.user.permission[permission].name == "list Extra_Hour"){
            this.canListExtra_HourPro = true;
          }
           if(this.user.permission[permission].name == "create Extra_Hour"){
            this.canAddExtra_HourPro = true;
          }
          if(this.user.permission[permission].name == "update Extra_Hour"){
            this.canUpdateExtra_HourPro = true;
          }
           if(this.user.permission[permission].name == "delete Extra_Hour"){
            this.canDeleteExtra_HourPro = true;
          }
           if(this.user.permission[permission].name == "approve Extra_Hour"){
            this.canApproveExtra_HourPro = true;
          }

        }
    },

             verifyRole(){
      this.roleAdminPro=this.roleFuncionarioPro=this.roleGestorFuncionarioPro=this.roleAssiduidadePro=this.roleRemuneracoesPro=this.roleUtilizadoresPro=false//aumente a lista de variaveis aqui

      this.roleRecrutamento=false,
this.roleHorasPro=false,
this.roleTurnosPro=false,
this.roleFeriasPro=false;

       for(let role in this.user.roles){

        
          if(this.user.roles[role].name == "Admin"){
            this.roleAdminPro = true;
          }
       
       if(this.user.roles[role].name == "Gestor de Funcionario"){
            this.roleGestorFuncionarioPro = true;
          }

          if(this.user.roles[role].name == "Gestor de Remunerações"){
            
            this.roleRemuneracoesPro = true;
            
          }
          if(this.user.roles[role].name == "Gestor de Assiduidade"){
            this.roleAssiduidadePro = true;
          }
          if(this.user.roles[role].name == "Funcionario"){
            this.roleFuncionarioPro = true;
          }
          if(this.user.roles[role].name == "Gestor de Licenças"){
            this.roleLicencasPro = true;
          }
          if(this.user.roles[role].name == "Gestor de Utilizadores"){
            this.roleUtilizadoresPro = true;
          }

          if(this.user.roles[role].name == "Gestor de Horas"){
            this.roleHorasPro = true;
          }
          
          if(this.user.roles[role].name == "Gestor de Ferias"){
            this.roleFeriasPro = true;
          }
          if(this.user.roles[role].name == "Gestor de Turnos"){
            this.roleTurnosPro = true;
          }

          if(this.user.roles[role].name == "Gestor de Recrutamento"){
            this.roleRecrutamento = true;
          }
        }
    }
},
 watch: {
        user() {
            this.verifyPermission()
            this.verifyRole()
      }
  
}

}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

</style>
